<template>
	<span>
		<button href="#" class="btn btn-primary btn-sm" role="button" @click="$emit('input', { event: 'edit', data: data })">
			<span class="glyphicon glyphicon-pencil" aria-hidden="true"></span>
		</button>
		<button href="#" class="btn btn-danger btn-sm" role="button" @click="$emit('input', { event: 'delete', data: data })">
			<span class="glyphicon glyphicon-trash" aria-hidden="true"></span>
		</button>
	</span>
</template>
<script>
export default {
	props: {
		config: {
			type: Object,
			required: true,
		},
		data: {
			type: Object,
			required: true
		}
	}
}
</script>